import { render, staticRenderFns } from "./WishlistProduct.vue?vue&type=template&id=abb55262&scoped=true"
import script from "./WishlistProduct.vue?vue&type=script&lang=js"
export * from "./WishlistProduct.vue?vue&type=script&lang=js"
import style0 from "./WishlistProduct.vue?vue&type=style&index=0&id=abb55262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb55262",
  null
  
)

export default component.exports